// extracted by mini-css-extract-plugin
export default {"container":"EditBillingDetailsDialog_container__GKiBJ","label":"EditBillingDetailsDialog_label__pjSlx","value":"EditBillingDetailsDialog_value__KtVrT"};